import React from 'react'
import type { ComponentProps, MacroComponentData } from '@enonic/react-components'
import VideoPrototype from '/react4xp/components/prototype/Video'

type VideoMacroData = {
	videoUrl?: string
	youtubeVideoId?: string
	thumbnail?: { src: string; alt: string }
	playLabel?: string
}

export const VideoMacro = ({ data }: ComponentProps<MacroComponentData>) => {
	const { videoUrl, youtubeVideoId, thumbnail, playLabel } = (data || {}) as VideoMacroData

	// No isPart and no wrapper element here, unlike the Video part: the macro sits in a
	// rich text field that already provides the container, and `.rich-text > .aspect-video`
	// spaces the player only while it is a direct child of the rich text block.
	return (
		<VideoPrototype
			videoId={youtubeVideoId}
			videoUpload={videoUrl ? { src: videoUrl } : undefined}
			thumbnail={thumbnail}
			playLabel={playLabel}
		/>
	)
}
